// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1kdw1","displayBlock":"modal_displayBlock__2pXyp","displayNone":"modal_displayNone__3SFYt","main":"modal_main__ppFuY","closeBtn":"modal_closeBtn__30DCG"};